import { FC, HTMLAttributes } from "react";
import styles from "./FullscreenContent.module.css";

const FullscreenContent: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className, ...rest } = props;
  const combinedClassName = className
    ? `${styles["root"]} ${className}`
    : styles["root"];
  return (
    <div className={combinedClassName} {...rest}>
      {props.children}
    </div>
  );
};

export default FullscreenContent;
